module.exports = __webpack_public_path__ + "static/media/lab_profile_form.81ca1c04.svg";